// extracted by mini-css-extract-plugin
export default {"root":"PageLoader_root__iuN5w"};